import { useBookingV2 } from "context/BookingV2Context";
import { useCartDispatch, useCartState } from "hooks/useCartV2";
import { useLang } from "hooks/useLang";
import React, { useState } from "react";
import AccreditationForm from "../AccreditationForm";

const Accreditation = () => {
  const { event } = useBookingV2();
  const cartState = useCartState();
  const cartDispatch = useCartDispatch();
  const { t, multiLangVars, lang } = useLang();

  type Answer = {
    question_id: string;
    answer: string;
  };

  const [answers, setAnswers] = useState<Answer[]>(
    cartState.accreditation || []
  );

  type ErrorMap = Record<string, string>; // { question_id: "Error message" }

  const [errors, setErrors] = useState<ErrorMap>({});

  const validate = (
    questionId: string,
    value: string,
    type: string,
    isRequired: boolean
  ) => {
    let error = "";
    const trimmed = (value || "").trim();

    // required check
    if (isRequired && !trimmed) {
      error = t("required");
    } else if (type === "text") {
      // if provided, ensure reasonable length
      if (trimmed && trimmed.length < 2) {
        error = t("text_valid_err");
      } else if (trimmed && trimmed.length > 50) {
        error = t("text_max_err");
      }
    } else if (type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (trimmed && !emailRegex.test(trimmed)) {
        error = t("email_valid_err");
      }
    } else if (type === "phone_number") {
      // Accept format like: 9665XXXXXXXX (no plus) — adapt if you need +966...
      const phoneRegex = /^9665\d{8}$/;
      if (trimmed && !phoneRegex.test(trimmed)) {
        error = t("phone_format_error");
      }
    }

    setErrors((prev) => ({
      ...prev,
      [questionId]: error,
    }));

    return error === "";
  };

  const handleChange = (
    questionId: string,
    value: string,
    type?: string,
    isRequired?: boolean
  ) => {
    // run validation (we still save the value even if invalid, but it's flagged)
    if (type) validate(questionId, value, type, !!isRequired);

    const updated = [...answers];
    const index = updated.findIndex((a) => a.question_id === questionId);

    if (index > -1) {
      updated[index] = { question_id: questionId, answer: value };
    } else {
      updated.push({ question_id: questionId, answer: value });
    }

    setAnswers(updated);

    cartDispatch({
      type: "SET_ACCREDITATION_DATA",
      payload: updated,
    });
  };

  return (
    // <div>Accreditation</div>
    <div className="p-6">
      <AccreditationForm
        questions={event?.accreditation?.questions || []}
        answers={answers}
        onChange={handleChange}
        errors={errors}
      />
    </div>
  );
};

export default Accreditation;
